import React from 'react'
import { Link } from 'react-router-dom'
import Seo from '../Seo/Seo'

const NotFound = () => {
  return (
    <>
      <Seo title='Page not found | CLI' description='The page you are looking for does not exist.' noindex />
      <header className='page_hero' style={{ paddingBottom: 'var(--section-y)' }}>
        <span className='home_eyebrow'>404</span>
        <h1>Page not found</h1>
        <p className='home_lead'>The page you are looking for doesn't exist or has moved.</p>
        <div className='cta_row'>
          <Link className='btn btn_primary' to='/'>Back to home</Link>
        </div>
      </header>
    </>
  )
}

export default NotFound
